import React, { Component } from 'react';

const maxLengthAllowed = 100;

class Motivo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: ''
        }
    }

    handleChange(event) {
        let supportsMaxLength = ('maxLength' in event.target);
        let evtValue = event.target.value;

        if (!supportsMaxLength) {
            let maxValue = event.target.getAttribute("maxlength");

            if (evtValue.length > maxValue) {
                evtValue = evtValue.substring(0, maxLengthAllowed);
            }
        }

        this.setState({ value: evtValue });
    }

    updateMotivoBloqueo() {
        this.props.setUserState(null, false, true)
        this.props.setMotivoBloqueo(this.state.value);
    }

    //MOTIVO OPCIONAL DE MENSAJE EN BLOQUEO
    render() {
        return (
            <div className="row">
                <div className="col-xs-12">
                    <p>Ingrese el motivo (opcional):</p>
                </div>
                <div className="col-xs-12 bottom-separator-xxs">
                    <textarea className="form-control"
                        value={this.state.value}
                        onChange={(event) => this.handleChange(event)}
                        maxLength={maxLengthAllowed} />
                </div>
                <div className="col-xs-12 text-right">
                    <button className="btn btn-secondary" type="button"
                        onClick={() => this.updateMotivoBloqueo()} >Listo</button>
                </div>
            </div >
        );
    }
}

export default Motivo;